

import _ from 'lodash';
import './certification.scss';

/* @ngInject */
export default function CertificationController(CertificationFactory, $stateParams, $state, $window, $sce) {
    const vm = this;

    vm.certificationPages = [];
    vm.guideColumns = [];
    vm.guides = [];
    vm.courseCategories = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.tlmsUserId = '';
    vm.isCertified = null;
    vm.finalExamInfo = null;
    vm.finalExamCertificate = null;
    vm.tlmsError = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.switchPage = function (page) {
        vm.currentPage = page;
        buildPageUrl();
        $state.go('certification', { certificationPage: page.pageName });
    };

    vm.getCourseUrl = function (courseId) {
        const newWindow = $window.open('');
        CertificationFactory.getCourseUrl(courseId).then((response) => {
            newWindow.location = response.data.Data;
        });
    };

    vm.parseCourseData = function (data) {
        return $sce.trustAsHtml(data);
    };

    vm.courseClicked = function (course) {
        if (course.Description !== '') {
            course.isCollapsed = !course.isCollapsed;
        }
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getCertificationPages();
        getCertificationColumns();
        getCertificationGuides();
        setInitialPage();
        buildPageUrl();
        getUserCourses();
    }

    function getCertificationPages() {
        vm.certificationPages = CertificationFactory.getCertificationPages();
    }

    function getCertificationColumns() {
        vm.guideColumns = CertificationFactory.getCertificationGuideColumns();
    }

    function getCertificationGuides() {
        vm.guides = CertificationFactory.getCertificationGuides();
    }

    function getUserCourses() {
        CertificationFactory.getUserCourses().then((response) => {
            if (response.data.ResultCode !== 1) {
                // Getting information about all other courses
                vm.tlmsUserId = response.data.Data.TLMSUserId;
                vm.isCertified = response.data.Data.IsCertified;

                if (vm.isCertified === true) {
                    vm.finalExamCertificate = CertificationFactory.getUserCertificate();
                }

                formatUserCourses(response.data.Data.Courses);

                // Getting information about the final exam
                vm.finalExamInfo = response.data.Data.CoursesCertification[0];
                CertificationFactory.getCourseUrl(vm.finalExamInfo.Id).then((response) => {
                    vm.finalExamInfo.Url = response.data.Data;
                });
            } else {
                vm.tlmsError = true;
            }
        });
    }

    function formatUserCourses(courses) {
        let formattedCourses = [];

        // Group the courses by courseType
        courses = _.groupBy(courses, 'CourseType');

        // Properly format the groupings
        _.each(courses, (value, key) => {
            formattedCourses.push({
                categoryName: key,
                courses: value,
            });
        });

        // Sort the formatted courses by categoryName
        formattedCourses = _.sortBy(formattedCourses, 'categoryName');

        // Remove the leading numbers from the categoryName now that we've sorted the array
        _.each(formattedCourses, (courseCategory) => {
            courseCategory.categoryName = courseCategory.categoryName.substring(1);
            courseCategory.courses.isCollapsed = true;
        });

        vm.courseCategories = formattedCourses;
    }

    function setInitialPage() {
        const pages = _.filter(vm.certificationPages, page => page.pageName === $stateParams.certificationPage);
        if (pages !== undefined && pages !== null) {
            vm.currentPage = pages[0];
        } else {
            vm.currentPage = vm.certificationPages[0];
        }
    }

    function buildPageUrl() {
        vm.pageUrl = `app/certification/${vm.currentPage.pageName}/certification_${vm.currentPage.pageName}.html`;
    }
}



// WEBPACK FOOTER //
// ./src/app/certification/certificationController.js